var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9936 0.0036087C14.5494 0.0036087 15 0.451526 15 1.00406C15 1.22654 14.9254 1.44267 14.788 1.61828L9.00644 9.00767L9 13.7262C9 13.9915 8.89464 14.246 8.70711 14.4336L7.17071 15.9707C7.13166 16.0098 7.06834 16.0098 7.02929 15.9707C7.01054 15.9519 7 15.9265 7 15.9V9.00767L1.21205 1.61828C0.8708 1.18213 0.949838 0.553575 1.38858 0.214352C1.56524 0.0777644 1.78266 0.0036087 2.00646 0.0036087H13.9936Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.63f49f03425aa306ec8f62dcdccc8bbf.svg";
export { ForwardRef as ReactComponent };